<template>
    <form style="width:520px" :key="reloadKey">
        <div class="pageTitle">
            <span class="md-title">{{ $t('user.profile.password.title') }}</span>
        </div>
        <!-- Hidden username input helps with correct password autofill -->
        <md-input :value="email"
                  autocomplete="username"
                  hidden
                  disabled
        ></md-input>
        <md-field :class="[{ 'md-error': errors.has('oldpwd') }]">
            <md-input v-model="form.oldpwd"
                      type="password"
                      autocomplete="current-password"
                      required
                      data-vv-name="oldpwd"
                      v-validate="modelValidations.oldpwd"
            ></md-input>
            <label>{{ $t("common.oldPassword") }}</label> <!-- Must be after input for autofill fix -->
            <span v-if="errors.has('oldpwd')" class="validation-error offset">{{ errors.first("oldpwd") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('pwd') }]">
            <md-input v-model="form.pwd"
                      type="password"
                      autocomplete="new-password"
                      required
                      data-vv-name="pwd"
                      v-validate="modelValidations.pwd"
            ></md-input>
            <label>{{ $t("common.password") }}</label> <!-- Must be after input for autofill fix -->
            <span v-if="errors.has('pwd')" class="validation-error offset">{{ errors.first("pwd") }}</span>
        </md-field>
        <div class="strength">
            <span v-if="strengthWith(form.pwd) >= 0 && form.pwd.length"></span>
            <span v-if="strengthWith(form.pwd) >= 3"></span>
            <span v-if="strengthWith(form.pwd) >= 4"></span>
        </div>
        <md-field :class="[{ 'md-error': errors.has('repwd') }]">
            <md-input v-model="form.repwd"
                      type="password"
                      autocomplete="new-password"
                      required
                      data-vv-name="repwd"
                      v-validate="modelValidations.repwd"
            ></md-input>
            <label>{{ $t("common.password.repeat") }}</label> <!-- Must be after input for autofill fix -->
            <span v-if="errors.has('repwd')" class="validation-error">{{ errors.first("repwd") }}</span>
        </md-field>
        <div class="flex flex_center">
            <md-button class="opacity_5" :class="{'md-primary': isFormValid}" @click="submit()">
                {{ $t("common.button.submit") }}
            </md-button>
        </div>
    </form>
</template>
<script>


import {userProfileApi} from "@/common/api/userProfileApi";
import {validateForm, validateRequiredFields} from "@/validation/validation";

export default {
    props: {
        email: { type: String, default: "" },
    },
    data() {
        return {
            modelValidations: {
                oldpwd: {
                    required: true
                },
                pwd: {
                    required: true,
                },
                repwd: {
                    required: true
                }
            },
            form: {
                oldpwd: "",
                pwd: "",
                repwd: ""
            },
	        reloadKey: 0
        };
    },
    methods: {
        submit() {
	        validateForm(this, this.$validator).then(() => {
                    userProfileApi.operation.changePassword(this.form)
                        .then(() => {
                            this.toastSuccess();

                            // Reset password fields
                            for (let field in this.form) {
                                this.form[field] = "";
                            }
                            this.$validator.reset();
	                        this.reloadKey++;
                        })
                    .catch(err => {
                        this.toast(err);
                    });
            }).catch(e => this.toast(e));
        },
    },
    computed: {
        isFormValid() {
            return validateRequiredFields(this.form, this.modelValidations);
        }
    }
};
</script>